import React from 'react'
import { useHistory } from 'react-router-dom'
import {
    findSavedCanonicalSearchKeys,
    searchKeysToFormattedValues,
} from '../../../utils/saved-searches/saved-search-refinement.util'
import { allCanonicalSearchKeys } from '../../../utils/saved-searches/canonical-search-values-parser.util'
// eslint-disable-next-line import/no-webpack-loader-syntax
import { IconArrowRight } from '@at/design-system-icons'
import {
    NewStyledGoToSavedSearchButton,
    NewStyledStyledGoToSavedSearchContainer,
    NewStyledYourSavedSearchFilters,
    NewStyledYourSavedSearchListingRow,
    NewStyledYourSaveSearchContainer,
    StyledSavedSearchName,
} from './your-saved-searches.styles'
import { SavedSearch } from '../../../patterns/saved-searches/save-search'
import { useSearchViewState } from '../../../contexts/search-view-state-context'
import { setSearchId } from '../../../utils/set-search-id'

export interface YourSavedSearchItemProps {
    savedSearch: SavedSearch
    handleHideModal: () => void
}

export const YourSavedSearchItem = ({ savedSearch, handleHideModal }: YourSavedSearchItemProps) => {
    const history = useHistory()
    const canonicalSearchValues = savedSearch.canonicalSearchValues
    const { toggleSearchFilter } = useSearchViewState()
    const searchKeys = findSavedCanonicalSearchKeys(allCanonicalSearchKeys, canonicalSearchValues)

    return (
        <>
            <NewStyledGoToSavedSearchButton
                onClick={() => {
                    handleHideModal()
                    toggleSearchFilter(false)
                    setSearchId()
                    return history.push(savedSearch.searchCriteria)
                }}
            >
                <NewStyledYourSaveSearchContainer>
                    {/* Search title */}
                    <StyledSavedSearchName as="h3" weight="500" data-testid="desktop-saved-search-name">
                        {savedSearch.name}
                    </StyledSavedSearchName>
                    {/* Search filters */}
                    <NewStyledYourSavedSearchListingRow>
                        <NewStyledYourSavedSearchFilters as="span" data-testid="your-saved-search-filters">
                            {searchKeysToFormattedValues(searchKeys, canonicalSearchValues).join(', ')}
                        </NewStyledYourSavedSearchFilters>
                    </NewStyledYourSavedSearchListingRow>
                </NewStyledYourSaveSearchContainer>
                <NewStyledStyledGoToSavedSearchContainer>
                    <IconArrowRight title="run search" viewBox="3 -3 24 24" />
                </NewStyledStyledGoToSavedSearchContainer>
            </NewStyledGoToSavedSearchButton>
        </>
    )
}
